<template lang="pug">
  r-table( 
    no-filters 
    no-search 
    ref='table'
    v-bind='tableProps'
    @detail='handleDetailClick' 
    @remove='handleRemoveClick' 
    )
</template>

<script>
//
import { mapState } from 'vuex'
import { RTable } from '@/components/reusable_components/next'
import HrFamilyAssignmentService from '@/services/api/HumanResource/HrFamilyAssignment'
//
export default {
  components: {
    RTable,
  },
  computed: {
    ...mapState('SnackbarModalModule', [
      'responseConfirm',
    ]),
  },
  data: () => ({
    selected: null,
  }),
  methods: {
    handleCreateClick() {
      this.$router.push({ name: 'family-assignment-create' })
    },
    handleDetailClick(event) {
      this.$router.push({ name: 'family-assignment-update', params: { id: event.item.id } })
    },
    handleRemoveClick(event) {
      this.selected = event.item
      this.showWarningSnackbar({
        title: 'Eliminar',
        message: '¿Confirma la eliminacion del item seleccionado?',
        confirm: 'eliminar',
      })
    },
    handleRemoveConfirm() {
      HrFamilyAssignmentService.delete(this.selected).then(() => {
        this.$refs.table.refresh()
        this.hideSnack()
      })
    },
  },
  mounted() {
    this.setTitle('Topes de asignacion familiar')
    this.setItems([
      {
        text: 'agregar tope de asignacion familiar',
        icon: 'add_circle',
        action: this.handleCreateClick,
      }
    ])
  },
  props: {
    tableProps: {
      type: Object,
      default: () => ({
        headers: HrFamilyAssignmentService.headers(),
        service: HrFamilyAssignmentService.model(),
      })
    },
  },
  watch: {
    responseConfirm(val) {
      console.log({ val })
      switch(val) {
        case 'eliminar': return this.handleRemoveConfirm()
      }
    }
  },
}
</script>
